const parede = {
  option: [
    { config: ["PP", "BRANCO Papel"], id: "32402487705679", price: "13990" },
    { config: ["P", "BRANCO Papel"], id: "32402487738447", price: "15990" },
    { config: ["M", "BRANCO Papel"], id: "32402487771215", price: "15990" },
    { config: ["G", "BRANCO Papel"], id: "32402487803983", price: "19990" },

    { config: ["PP", "PRETO Besouro"], id: "32402487836751", price: "15990" },
    { config: ["P", "PRETO Besouro"], id: "32402487869519", price: "17990" },
    { config: ["M", "PRETO Besouro"], id: "32402487902287", price: "17990" },
    { config: ["G", "PRETO Besouro"], id: "32402487935055", price: "21990" },
  ],
};
const bag = {
  option: [
    { config: ["PP"], id: "39420408922191", price: "8990" },
    { config: ["P"], id: "39420408954959", price: "9990" },
    { config: ["M"], id: "39420408954959", price: "9990" },
    { config: ["G"], id: "39420408954959", price: "9990" },
  ],
};

const divaddMoreProductsParede = document.getElementById(
  "addMoreProductsParede"
);
const checkboxParede = document.getElementById("addParede");
divaddMoreProductsParede.addEventListener("click", function (e) {
  // Evita a ação padrão de marcar/desmarcar o checkbox quando ele próprio é clicado.
  if (e.target !== checkboxParede) {
    checkboxParede.checked = !checkboxParede.checked;
    console.log("click parede");
    updatePriceParede(); // Chame sua função aqui se necessário
  }
  if (checkboxParede.checked) {
    divaddMoreProductsParede.classList.add("checked");
  } else {
    divaddMoreProductsParede.classList.remove("checked");
  }
});

const divaddMoreProductsBag = document.getElementById("addMoreProductsBag");
const checkboxBag = document.getElementById("addBag");
divaddMoreProductsBag.addEventListener("click", function (e) {
  // Evita a ação padrão de marcar/desmarcar o checkbox quando ele próprio é clicado.
  if (e.target !== checkboxBag) {
    checkboxBag.checked = !checkboxBag.checked;
    console.log("click bag");
    updatePriceParede(); // Chame sua função aqui se necessário
  }
  if (checkboxBag.checked) {
    divaddMoreProductsBag.classList.add("checked");
  } else {
    divaddMoreProductsBag.classList.remove("checked");
  }
});

function changePic() {
  let optionValue = localVariant.option3;
  let imgElement = document.querySelector(".paredebackgound img");

  // Comparar e atualizar a imagem
  if (optionValue === "BRANCO C/ CINZA") {
    imgElement.src =
      "https://cdn.shopify.com/s/files/1/0293/3024/3663/products/Parede-Hidrante.jpg?v=1691409124";
  } else if (optionValue === "BRANCO C/ PRETO") {
    imgElement.src =
      "https://cdn.shopify.com/s/files/1/0293/3024/3663/products/Parede-Hidrante.jpg?v=1691409124";
  } else if (optionValue === "PRETO C/ CINZA") {
    imgElement.src =
      "https://cdn.shopify.com/s/files/1/0293/3024/3663/products/Parede-Hidrante-5.jpg?v=1691409135";
  } else if (optionValue === "PRETO C/ PRETO") {
    imgElement.src =
      "https://cdn.shopify.com/s/files/1/0293/3024/3663/products/Parede-Hidrante-5.jpg?v=1691409135";
  }
}

document.addEventListener("localVariantChanged", function (e) {
  //changePic();
});

function updatePriceParede() {
  console.log("updatePriceParede");
  let addParedeCheckbox = document.getElementById("addParede").checked;
  let addBagCheckbox = document.getElementById("addBag").checked;

  var tempPrice = null;
  var tempPriceFull = null;
  var comparePrice = null;
  var desconto = null;
  let precoParede = null;
  let precoBag = null;
  var corParede = null;
  let corParede_2 = null;
  let codeParede = null;
  let descontoBag = 0;
  let descontoParede = 0;
  let b = document.getElementsByClassName("addOnPrice__parede__Full");
  console.log(b.length);
  console.log(b);
  if (b.length > 0) {
    descontoBag = 2000;
    descontoParede = 3000;
  } else {
    descontoBag = 0;
    descontoParede = 0;
  }

  for (var i = 0; i <= 7; i++) {
    corParede = window.localVariant.option3;
    corParede = corParede.split(" ", 1);
    corParede = corParede.toString();
    corParede_2 = parede.option[i].config[1];
    corParede_2 = corParede_2.split(" ", 1);
    corParede_2 = corParede_2.toString();

    if (
      window.localVariant.option1 == parede.option[i].config[0] &&
      corParede == corParede_2
    ) {
      precoParede = parede.option[i].price - descontoParede;
      precoParede = parseInt(precoParede);
      let a = document.getElementsByClassName("addOnPrice__parede");
      let b = document.getElementsByClassName("addOnPrice__parede__Full");

      if (b.length > 0) {
        a[0].innerHTML =
          "" +
          theme.Currency.formatMoney(precoParede, theme.settings.moneyFormat) +
          ' <spam style="font-size: 9px;">' +
          theme.Currency.formatMoney(
            descontoParede,
            theme.settings.moneyFormat
          ) +
          " OFF</spam>";
        b[0].innerHTML =
          "" +
          theme.Currency.formatMoney(
            precoParede + descontoParede,
            theme.settings.moneyFormat
          );
      } else {
        a[0].innerHTML =
          "" +
          theme.Currency.formatMoney(precoParede, theme.settings.moneyFormat);
      }
      break;
    }
  }

  for (var i = 0; i <= 4; i++) {
    if (window.localVariant.option1 == bag.option[i].config[0]) {
      precoBag = bag.option[i].price - descontoBag;
      precoBag = parseInt(precoBag);
      let a = document.getElementsByClassName("addOnPrice__bag");
      let b = document.getElementsByClassName("addOnPrice__bag__Full");

      if (b.length > 0) {
        a[0].innerHTML =
          "" +
          theme.Currency.formatMoney(precoBag, theme.settings.moneyFormat) +
          ' <spam style="font-size: 9px;">' +
          theme.Currency.formatMoney(descontoBag, theme.settings.moneyFormat) +
          " OFF</spam>";
        b[0].innerHTML =
          "" +
          theme.Currency.formatMoney(
            precoBag + descontoBag,
            theme.settings.moneyFormat
          );
      } else {
        a[0].innerHTML =
          "" + theme.Currency.formatMoney(precoBag, theme.settings.moneyFormat);
      }
      break;
    }
  }

  tempPriceFull = window.localVariant.price;
  comparePrice = localVariant.compare_at_price;

  desconto =
    desconto + (localVariant.compare_at_price - window.localVariant.price);

  if (window.parcelNumber != undefined) {
    tempPrice = window.localVariant.price;

    if (addParedeCheckbox == true) {
      tempPrice = parseInt(tempPrice) + parseInt(precoParede);
      tempPriceFull = tempPrice;
      comparePrice =
        comparePrice + parseInt(precoParede) + parseInt(descontoParede);
      desconto = desconto + descontoParede;
    }

    if (addBagCheckbox == true) {
      tempPrice = parseInt(tempPrice) + parseInt(precoBag);
      tempPriceFull = tempPrice;
      comparePrice = comparePrice + parseInt(precoBag) + parseInt(descontoBag);
      desconto = desconto + descontoBag;
    }

    for (var i = window.parcelNumber; i > 0; i--) {
      var parcelVal = tempPrice / i;
      if (window.minParcelamento <= parcelVal) {
        parcelVal = theme.Currency.formatMoney(
          parcelVal,
          theme.settings.moneyFormat
        );
        tempPriceFull = theme.Currency.formatMoney(
          tempPriceFull,
          theme.settings.moneyFormat
        );
        comparePrice = theme.Currency.formatMoney(
          comparePrice,
          theme.settings.moneyFormat
        );
        desconto = theme.Currency.formatMoney(
          desconto,
          theme.settings.moneyFormat
        );

        document.querySelector("[data-product-price]").innerHTML =
          tempPriceFull;

        if (document.querySelector("[data-save-price]") != null) {
          document.querySelector("[data-save-price]").innerHTML =
            "Economize " + desconto;
        }

        if (document.querySelector("[data-compare-price]") != null) {
          document.querySelector("[data-compare-price]").innerHTML =
            comparePrice;
        }

        console.log("preço modificado");
        break;
      }
    }

    tempPrice = window.localVariant.price;
  }

  var event = new Event("localVariantChanged");
  document.dispatchEvent(event);
}

function setupAddMore() {
  console.log("setup add more");
  let addParedeCheckbox = document.getElementById("addParede").checked;
  let addBagCheckbox = document.getElementById("addBag").checked;

  var tempPrice = null;
  var tempPriceFull = null;
  let precoParede = null;
  let precoBag = null;
  var corParede = null;
  let corParede_2 = null;
  let codeParede = null;

  for (var i = 0; i <= 7; i++) {
    corParede = window.localVariant.option3;
    corParede = corParede.split(" ", 1);
    corParede = corParede.toString();
    corParede_2 = parede.option[i].config[1];
    corParede_2 = corParede_2.split(" ", 1);
    corParede_2 = corParede_2.toString();

    if (
      window.localVariant.option1 == parede.option[i].config[0] &&
      corParede == corParede_2
    ) {
      precoParede = parede.option[i].price;
      precoParede = parseInt(precoParede);
      let a = document.getElementsByClassName("addOnPrice__parede");
      a[0].innerHTML =
        "+ " +
        theme.Currency.formatMoney(precoParede, theme.settings.moneyFormat);
      break;
    }
  }

  for (var i = 0; i <= 4; i++) {
    if (window.localVariant.option1 == bag.option[i].config[0]) {
      precoBag = bag.option[i].price;
      precoBag = parseInt(precoBag);
      let a = document.getElementsByClassName("addOnPrice__bag");
      a[0].innerHTML =
        "+ " + theme.Currency.formatMoney(precoBag, theme.settings.moneyFormat);
      break;
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  /*
  var form = document.getElementById(
    "AddToCartForm-template--16100942544975__main-6665290743887"
  );

 */
  var form = document.querySelector('[id^="AddToCartForm-template"]');
  const addToCartButton = document.querySelector('button[name="add"]');
  const floatingButton = document.querySelector(".btn-floating");
  const addToCartText = document.querySelector("span[data-add-to-cart-text]");

  function handleButtonClick(event) {
    event.preventDefault(); // Isso impede o comportamento padrão
    // Insira aqui qualquer outra lógica ou função que você queira executar
    addToCartText.innerHTML =
      '  <div class="spinner-container"><div class="spinner"></div></div>';
    floatingButton.innerHTML =
      ' <div class="spinner-container"><div class="spinner"></div></div>'; // Adiciona spinner ao botão customizado
    // Obter o ID da variante selecionada
    var selectedVariantId = form.querySelector('select[name="id"]').value;
    // ID do outro produto a ser adicionado.

    let paredeBrancaMini = 32402487705679;
    let paredeBrancaPequena = 32402487738447;
    let paredeBrancaMedia = 32402487771215;
    let paredeBrancaGrande = 32402487803983;

    let paredePretaMini = 32402487836751;
    let paredePretaPequena = 32402487869519;
    let paredePretaMedia = 32402487902287;
    let paredePretaGrande = 32402487935055;

    var corParede = null;
    let corParede_2 = null;
    let codeParede = null;
    let codeBag = null;

    for (var i = 0; i <= 7; i++) {
      corParede = window.localVariant.option3;
      corParede = corParede.split(" ", 1);
      corParede = corParede.toString();
      corParede_2 = parede.option[i].config[1];
      corParede_2 = corParede_2.split(" ", 1);
      corParede_2 = corParede_2.toString();

      if (
        window.localVariant.option1 == parede.option[i].config[0] &&
        corParede == corParede_2
      ) {
        codeParede = parede.option[i].id;
        break;
      }
    }

    for (var i = 0; i <= 4; i++) {
      if (window.localVariant.option1 == bag.option[i].config[0]) {
        codeBag = bag.option[i].id;
        codeBag = parseInt(codeBag);
        break;
      }
    }

    let checkedAddParede = document.getElementById("addParede").checked;
    let addBagCheckbox = document.getElementById("addBag").checked;
    var formData = null;

    if (checkedAddParede == true && addBagCheckbox == false) {
      // Adicionar ambos os itens ao carrinho
      addItemsToCart([selectedVariantId, codeParede]);
    }

    if (checkedAddParede == false && addBagCheckbox == true) {
      // Adicionar ambos os itens ao carrinho
      addItemsToCart([selectedVariantId, codeBag]);
    }

    if (checkedAddParede == true && addBagCheckbox == true) {
      // Adicionar ambos os itens ao carrinho
      addItemsToCart([selectedVariantId, codeParede, codeBag]);
    }

    if (checkedAddParede == false && addBagCheckbox == false) {
      // Adicionar ambos os itens ao carrinho
      addItemsToCart([selectedVariantId]);
    }
  }
  function teste() {
    console.log("teste do botao");
  }
  if (addToCartButton) {
    addToCartButton.addEventListener("click", handleButtonClick);
  } else {
    console.error("Botão original não encontrado");
  }

  // Anexar o mesmo evento ao botão customizado
  if (floatingButton) {
    console.log("Botão encontrado");
    floatingButton.addEventListener("click", handleButtonClick);
    console.log();
  } else {
    console.error("Botão customizado não encontrado");
  }

  //setupAddMore();
  //changePic();

  document
    .querySelectorAll('.variant-input input[type="radio"]')
    .forEach(function (radio) {
      radio.addEventListener("change", function (e) {
        if (e.target.checked) {
          console.log("A variante selecionada mudou para:", e.target.value);
          updatePriceParede();
        }
      });
    });

  document.querySelectorAll(".addMoreProducts").forEach(function (div) {
    div.addEventListener("click", function (e) {
      console.log(
        "Div .addMoreProducts foi clicada, opção selecionada mudou para:"
      );
      updatePriceParede();
    });
  });
});

function addItemsToCart(variantIds) {
  var addUrl = "/cart/add.js";
  var addNextItem = function (index) {
    if (index >= variantIds.length) {
      // Todos os itens foram adicionados
      console.log("Todos os itens foram adicionados ao carrinho.");
      // Redirecionar para o carrinho ou atualizar a página, se desejado
      // Adiciona um atraso de 100 milissegundos antes de executar o código
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent("cart:build"));
      }, 150);
      setTimeout(function () {
        document.dispatchEvent(new Event("cart:open"));
        const addToCartText = document.querySelector(
          "span[data-add-to-cart-text]"
        );
        const floatingButton = document.querySelector(".btn-floating");
        addToCartText.innerHTML = "Adicionar ao carrinho";
        floatingButton.innerHTML = "Adicionar ao carrinho";
      }, 250);

      return;
    }

    var data = {
      quantity: 1,
      id: variantIds[index],
    };

    fetch(addUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((json) => {
        console.log("Item adicionado ao carrinho:", json);
        // Chama a próxima iteração
        addNextItem(index + 1);
      })
      .catch((error) => {
        console.error("Erro ao adicionar o item ao carrinho:", error);
      });
  };

  // Iniciar o loop
  addNextItem(0);
}

function showInfoModalParede() {
  document.getElementById("infoModalParede").style.display = "block";
  event.stopPropagation();
}

function closeInfoModalParede() {
  document.getElementById("infoModalParede").style.display = "none";
}

function showInfoModalBag() {
  document.getElementById("infoModalBag").style.display = "block";
  event.stopPropagation();
}

function closeInfoModalBag() {
  document.getElementById("infoModalBag").style.display = "none";
}
